import React from 'react';
import { Badge } from '../types';

interface BadgeCardProps {
  badge: Badge;
}

const BadgeCard: React.FC<BadgeCardProps> = ({ badge }) => {
  return (
    <div className={`flex flex-col items-center p-4 rounded-2xl border-2 ${badge.unlocked ? 'bg-white border-yellow-400 shadow-md' : 'bg-slate-100 border-slate-200 opacity-60 grayscale'}`}>
      <div className="text-4xl mb-2">
        {badge.icon}
      </div>
      <h3 className="font-bold text-sm text-center brand-font">{badge.name}</h3>
      <p className="text-xs text-slate-500 text-center mt-1">{badge.description}</p>
    </div>
  );
};

export default BadgeCard;
